import { graphql } from 'react-apollo';
import { statisticsQuery } from '../graphql/statistics.query';
import moment from 'moment';

export const withStatistics = graphql(statisticsQuery, {
  options: (props) => {
    // Use props.startTime and props.endTime if available, otherwise use defaults
    const startTime = props.startTime ? props.startTime.utc().format() : moment().subtract(7, 'days').startOf('day').utc().format();
    const endTime = props.endTime ? props.endTime.utc().format() : moment().endOf('day').utc().format();
    
    const variables = {
      startTime,
      endTime,
    };
    
    console.log('Statistics query variables:', variables);
    console.log('Statistics props:', props);
    
    return {
      fetchPolicy: 'network-only',
      variables,
    };
  },
  props: ({ data }) => {
    console.log('Statistics query data:', data);
    console.log('Statistics query loading:', data?.loading);
    console.log('Statistics query error:', data?.error);
    console.log('Statistics query statistics:', data?.statistics);
    
    if (data?.error) {
      console.error('Statistics query error details:', data.error);
    }
    
    return {
      statisticsData: (data.loading || data.error) ? {} : data.statistics,
      data, // Pass the data object for refetch functionality
    };
  },
});
